import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import {
  getTopupInProgressRequest,
  adminTopupLoadApiUrl
} from '@epi-api/topupLoad';
import { fetchPost as Post } from '@epi-helpers/FetchHelpers';
import { showNotification } from '@epi-actions/overlays';
import { TopupFormStatuses } from '@epi-constants/topupForm';

export const useAdminTopupRequest = (
  setShowConfirmationModal,
  isToggle,
  showOnHoldBtn,
  setTopupRequestStatus
) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [isTopupPending, setIsTopupPending] = useState(false);
  const [isTopupProcessing, setIsTopupProcessing] = useState(false);
  const [summaryId, setSummaryId] = useState<string | undefined>(undefined);
  const timerRef = useRef<null | number>(null);

  const getTopupInProgress = async () => {
    const response = await getTopupInProgressRequest();
    if (!response) return;
    setIsTopupProcessing(response.isTopUpLoadInProgress);
    if (response.ids?.length) {
      setSummaryId(prev => prev ?? response.ids[0]);
    }

    if (response.isTopUpLoadInProgress) {
      timerRef.current = window.setTimeout(() => {
        getTopupInProgress();
      }, 3000);
    }
  };

  const postAdminTopupRequest = payload => {
    setIsTopupPending(true);
    setTopupRequestStatus(null);
    setShowConfirmationModal(false);

    const onSuccess = async response => {
      setSummaryId(response.topUpLoadId);
      setIsTopupProcessing(true);
      setIsTopupPending(false);
      setTopupRequestStatus(TopupFormStatuses.SUCCESS);
    };
    const onFailure = error => {
      const errorCode =
        error?.content?.errors?.length > 0
          ? error.content.errors[0].code
          : null;

      if (errorCode && t(`messages.${errorCode}`)) {
        dispatch(
          showNotification({ message: `messages.${errorCode}` }, 'error')
        );
      } else {
        dispatch(showNotification({ message: 'messages.error' }, 'error'));
      }

      setIsTopupPending(false);
      setTopupRequestStatus(TopupFormStatuses.FAIL);
    };

    return Post(
      adminTopupLoadApiUrl,
      {
        ...payload,
        showOnHoldBeneficiaries: showOnHoldBtn ? isToggle : null
      },
      onSuccess
    ).catch(onFailure);
  };

  useEffect(() => {
    getTopupInProgress();
  }, [isTopupProcessing]);

  useEffect(() => {
    return () => {
      if (timerRef.current !== null) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return {
    postAdminTopupRequest,
    isTopupPending,
    isTopupProcessing,
    summaryId
  };
};
